<div class="_container bg-col-w flex-column flex-justify-center overflow-y-auto pos-relative">
    <button class="pos-absolute top-3 right-3"
            (click)="close()">
        <i class="icon-close"
           style="font-size: 16px;"></i>
    </button>
    <div class="wrap center">
        <h3 class="o1 uppercase p-r-6 p-l-6"
            *iCms="'title' of content"></h3>
        <p class="h5 m-t col-11 p-r-6 p-l-6"
           *iCms="'description' of content"></p>
        <ng-form #form="ngForm">
            <!-- Nickname Input -->
            <div class="m-t-6 p-r p-l left">
                <input-wrap [required]="true"
                            [canShowValidate]="!!nickname">
                    <input type="text"
                           class="input"
                           name="nickname"
                           required
                           validatePattern="nickname"
                           [muiInput]="'Your nickname' | translate"
                           [(ngModel)]="nickname"
                           maxlength="40" />
                </input-wrap>
            </div>
            <div class="m-t p-r p-l left">
                <input-wrap>
                    <input type="date"
                           class="input"
                           name="dob"
                           [muiInput]="'Date of birth'| translate"
                           [(ngModel)]="dob"
                           validateDobRange
                           required>
                </input-wrap>
            </div>
            <p class="p2 col-11 p-r p-l m-t-5"
               *iCms="'checkboxDescription' of content; content: 'html', skipEmpty: true"></p>
            <div class="m-t-2 block left p-r p-l flex flex-justify-center w-12">
                <input-wrap>
                    <checkbox required
                              [name]="'loyaltyTerms'"
                              [checked]="acceptLoyaltyTerms"
                              [(ngModel)]="acceptLoyaltyTerms"
                              class="_checkboxPosition">
                        <span class="p2"
                              *iCms="'checkboxTitle' of content"></span>
                    </checkbox>
                </input-wrap>
            </div>

        </ng-form>
        @if (isUserUnder13()) {
        <div class="p2 col-error m-t-6 center"
             *iCms="'ageRestrictionMessage' of content">
        </div>
        }
        <button class="button w-12 m-t-8"
                [disabled]="!acceptLoyaltyTerms || !dob || !nickname || form.invalid"
                [class.busy]="submitStatus.busy"
                (click)="confirm()"
                style="display: inline-flex; justify-content: center; align-items: center;">
            <span *iCms="'continueButtonText' of content"></span>
        </button>
        <result [status]="submitStatus"></result>
    </div>
</div>
